export default {
    methods: {
        async getCityFromZipCode(zip, callback) {
            fetch(
                'https://ws.geonorge.no/adresser/v1/sok?postnummer='+zip+'&filtrer=adresser.poststed&treffPerSide=1'
            ).then((res) => {
                res.json().then((json) => {
                    callback(json)
                });
            });
        }
    }
}